module.exports = __webpack_public_path__ + "img/valuationbanner3.1f5349ee.png";